import { render, staticRenderFns } from "./courseOnline.vue?vue&type=template&id=4890cb3e&scoped=true&"
import script from "./courseOnline.vue?vue&type=script&lang=js&"
export * from "./courseOnline.vue?vue&type=script&lang=js&"
import style0 from "./courseOnline.vue?vue&type=style&index=0&id=4890cb3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890cb3e",
  null
  
)

export default component.exports